// import React from 'react';

export const personContactIcons = {
  linkedin: 'lab la-linkedin',
  github: 'lab la-github-square',
  twitter: 'lab la-twitter-square',
  youtube: 'lab la-youtube-square',
  facebook: 'lab la-facebook-square',
  instagram: 'lab la-instagram',
  web: 'las la-globe',
  phone: 'las la-phone-square',
  mail: 'las la-at',
};

export const iconsByType = {
  field: 'la la-user-friends',
  role: 'la la-user-circle',
  skill: 'la la-check-circle',
  'soft-skill': 'la la-user-alt',
  company: 'la la-building',
  city: 'la la-city',
  country: 'la la-globe',
  employment: 'la la-file-contract',
  benefit: 'la la-cube',
  money: 'la la-money-bill-alt',
  rate: 'la la-money-bill-alt',
  text: 'la la-file-alt',
  language: 'la la-language',
  companySize: 'la la-users',
  homeoffice: 'la la-home',
  remoteWork: 'la la-globe',
  suitableFor: 'la la-user-tie',
};

export const laClassBySlug = {
  'node-dot-js': 'lab la-node-js',
  react: 'lab la-react',
  jsx: 'lab la-react',
  'react-native': 'lab la-react',
  java: 'lab la-java',
  javascript: 'lab la-js-square',
  es6: 'lab la-js-square',
  'vanilla-js': 'lab la-js-square',
  php: 'lab la-php',
  'php-frameworks': 'lab la-php',
  'php-7': 'lab la-php',
  'php-8': 'lab la-php',
  git: 'lab la-git-square',
  docker: 'lab la-docker',
  python: 'lab la-python',
  'vue-dot-js': 'lab la-vuejs',
  angular: 'lab la-angular',
  angularjs: 'lab la-angular',
  android: 'lab la-android',
  'android-sdk': 'lab la-android',
  'native-android-development': 'lab la-android',
  'android-studio': 'lab la-android',
  ios: 'lab la-apple',
  'ios-design': 'lab la-apple',
  'ios-programming': 'lab la-apple',
  html: 'lab la-html5',
  'html5-apis': 'lab la-html5',
  html5: 'lab la-html5',
  swift: 'lab la-swift',
  sass: 'lab la-sass',
  less: 'lab la-less',
  gulp: 'lab la-gulp',
  aws: 'lab la-aws',
  'aws-command-line-interface-cli': 'lab la-aws',
  svn: 'las la-code-branch',
  jira: 'lab la-jira',
  'jira-service-desk': 'lab la-jira',
  confluence: 'lab la-confluence',
  bitbucket: 'lab la-bitbucket',
  'bitbucket-server': 'lab la-bitbucket',
  wordpress: 'lab la-wordpress',
  gitlab: 'lab la-gitlab',
  'gitlab-ci': 'lab la-gitlab',
  github: 'lab la-github',
  ubuntu: 'lab la-ubuntu',
  centos: 'lab la-centos',
  fedora: 'lab la-fedora',
  redhat: 'lab la-redhat',
  suse: 'lab la-suse',
  linux: 'lab la-linux',
  jenkins: 'lab la-jenkins',
  css: 'lab la-css3',
  css3: 'lab la-css3',
  'ember-dot-js': 'lab la-ember',
  erlang: 'lab la-erlang',
  figma: 'lab la-figma',
  grunt: 'lab la-grunt',
  joomla: 'lab la-joomla',
  magento: 'lab la-magento',
  markdown: 'lab la-markdown',
  npm: 'lab la-npm',
  opencart: 'lab la-opencart',
  salesforce: 'lab la-salesforce',
  slack: 'lab la-slack',
  sketch: 'lab la-sketch',
  'suse-linux-enterprise-server': 'lab la-suse',
  'redhat-enterprise-linux-rhel': 'lab la-redhat',
  trello: 'lab la-trello',
  sourcetree: 'lab la-sourcetree',
  skype: 'lab la-skype',
  xml: 'la la-code',
  atlassian: 'lab la-atlassian',
  laravel: 'lab la-laravel',
  dropbox: 'lab la-dropbox',
  mailchimp: 'lab la-mailchimp',
  symfony: 'lab la-symfony',
  'raspberry-pi': 'lab la-raspberry-pi',
  adobe: 'lab la-adobe',
  windows: 'lab la-windows',
  macos: 'lab la-apple',
  literatura: 'las la-book-open',

  redux: 'skilleto-icon-redux',
  json: 'skilleto-icon-json',
  jquery: 'skilleto-icon-jquery',
  'jquery-ui': 'skilleto-icon-jquery',
  'jquery-mobile': 'skilleto-icon-jquery',
  photoshop: 'skilleto-icon-photoshop',
  'adobe-photoshop': 'skilleto-icon-photoshop',
  'photoshop-document-psd': 'skilleto-icon-photoshop',
  webpack: 'skilleto-icon-webpack',
  graphql: 'skilleto-icon-graphql',
  electron: 'skilleto-icon-electron',
  mysql: 'skilleto-icon-mysql',
  postgresql: 'skilleto-icon-postgresql',
  typescript: 'skilleto-icon-typescript',
  elasticsearch: 'skilleto-icon-elasticsearch',
  'dot-net': 'skilleto-icon-dot-net',
  'dot-net-core': 'skilleto-icon-dot-net',
  'asp-dot-net': 'skilleto-icon-dot-net',
  'c-sharp': 'skilleto-icon-c-sharp',
  'c-plus-plus': 'skilleto-icon-c-plus-plus',
  rabbitmq: 'skilleto-icon-rabbitmq',
  ansible: 'skilleto-icon-ansible',
  django: 'skilleto-icon-django',
  oracle: 'skilleto-icon-oracle',
  'oracle-pl': 'skilleto-icon-oracle',
  'oracle-databases': 'skilleto-icon-oracle',
  'oracle-sql': 'skilleto-icon-oracle',
  'oracle-applications': 'skilleto-icon-oracle',
  'oracle-business-intelligence-enterprise-edition-obiee': 'skilleto-icon-oracle',
  'oracle-weblogic': 'skilleto-icon-oracle',
  'oracle-e-business-suite': 'skilleto-icon-oracle',
  'oracle-endeca': 'skilleto-icon-oracle',
  'oracle-data-guard': 'skilleto-icon-oracle',
  'oracle-eloqua': 'skilleto-icon-oracle',
  'oracle-exadata-database-machine': 'skilleto-icon-oracle',
  'oracle-essbase': 'skilleto-icon-oracle',
  'oracle-tuxedo': 'skilleto-icon-oracle',
  'oracle-application-framework-oaf': 'skilleto-icon-oracle',
  'oracle-grid-engine': 'skilleto-icon-oracle',
  'oracle-exalogic': 'skilleto-icon-oracle',
  'oracle-reports': 'skilleto-icon-oracle',
  'oracle-developer-2000': 'skilleto-icon-oracle',
  'oracle-loyalty-analytics': 'skilleto-icon-oracle',
  bash: 'skilleto-icon-bash',
  azure: 'skilleto-icon-azure',
  mongodb: 'skilleto-icon-mongodb',
  redis: 'skilleto-icon-redis',
  maven: 'skilleto-icon-maven',
  spring: 'skilleto-icon-spring',
  'spring-mvc': 'skilleto-icon-spring',
  'spring-boot': 'skilleto-icon-spring',
  'spring-security': 'skilleto-icon-spring',
  'spring-batch': 'skilleto-icon-spring',
  'spring-cloud': 'skilleto-icon-spring',
  'spring-integration': 'skilleto-icon-spring',
  'spring-ioc': 'skilleto-icon-spring',
  'spring-framework-jdbc': 'skilleto-icon-spring',
  'spring-xd': 'skilleto-icon-spring',
  'spring-framework': 'skilleto-icon-spring',
  kubernetes: 'skilleto-icon-kubernetes',
  'aws-kubernetes': 'skilleto-icon-kubernetes',
  kafka: 'skilleto-icon-kafka',
  rest: 'skilleto-icon-rest',
  'rest-api': 'skilleto-icon-rest',
  codeship: 'skilleto-icon-codeship',
  nette: 'skilleto-icon-nette',
  citrix: 'skilleto-icon-citrix',
  'citrix-netscaler': 'skilleto-icon-citrix',
  'citrix-xenserver': 'skilleto-icon-citrix',
  'citrix-access-gateway': 'skilleto-icon-citrix',
  'citrix-xenapp': 'skilleto-icon-citrix',
  'citrix-load-balancer': 'skilleto-icon-citrix',
  cypress: 'skilleto-icon-cypress',
  selenium: 'skilleto-icon-selenium',
  jasmine: 'skilleto-icon-jasmine',
  go: 'skilleto-icon-go',
  'next-js': 'skilleto-icon-next-js',
  'nest-js': 'skilleto-icon-nest-js',
  terraform: 'skilleto-icon-terraform',
  'visual-studio-code': 'skilleto-icon-visual-studio-code',
  sentry: 'skilleto-icon-sentry',
  storybook: 'skilleto-icon-storybook',
  'microsoft-teams': 'skilleto-icon-microsoft-teams',
  'kraken-io': 'skilleto-icon-kraken-io',
  prometheus: 'skilleto-icon-prometheus',
  gmail: 'skilleto-icon-gmail',
  openapi: 'skilleto-icon-openapi',
  kibana: 'skilleto-icon-kibana',
  logstash: 'skilleto-icon-logstash',
  apache: 'skilleto-icon-apache',
  ruby: 'skilleto-icon-ruby',
  'ruby-on-rails': 'skilleto-icon-ruby-on-rails',
  puppet: 'skilleto-icon-puppet',
  appium: 'skilleto-icon-appium',
  postman: 'skilleto-icon-postman',
  kotlin: 'skilleto-icon-kotlin',
  dart: 'skilleto-icon-dart',
  flutter: 'skilleto-icon-flutter',
  'microsoft-excel': 'skilleto-icon-microsoft-excel',
  hibernate: 'skilleto-icon-hibernate',
  chef: 'skilleto-icon-chef',
  consul: 'skilleto-icon-consul',
  'docker-swarm': 'skilleto-icon-docker-swarm',
  'team-foundation-server-tfs': 'skilleto-icon-team-foundation-server-tfs',
  tomcat: 'skilleto-icon-tomcat',
  nginx: 'skilleto-icon-nginx',
  grafana: 'skilleto-icon-grafana',
  swagger: 'skilleto-icon-swagger',
  firebase: 'skilleto-icon-firebase',
  gradle: 'skilleto-icon-gradle',
  tensorflow: 'skilleto-icon-tensorflow',
  apollo: 'skilleto-icon-apollo',
  scss: 'skilleto-icon-scss',
  ionic: 'skilleto-icon-ionic',
  scala: 'skilleto-icon-scala',
  akka: 'skilleto-icon-akka',
  sql: 'skilleto-icon-sql',
  't-sql': 'skilleto-icon-sql',
  sap: 'skilleto-icon-sap',
  'sap-abap': 'skilleto-icon-sap',
  'sap-erp': 'skilleto-icon-sap',
  'sap-business-objects': 'skilleto-icon-sap',
  'sap-hana': 'skilleto-icon-sap',
  'sap-r-3': 'skilleto-icon-sap',
  'sap-bw': 'skilleto-icon-sap',
  'sap-netweaver': 'skilleto-icon-sap',
  'sap-bi': 'skilleto-icon-sap',
  'sap-powerdesigner': 'skilleto-icon-sap',
  'sap-ariba': 'skilleto-icon-sap',
  'sap-qm': 'skilleto-icon-sap',
  'sap-mm': 'skilleto-icon-sap',
  'sap-integration': 'skilleto-icon-sap',
  'sap-code-vulnerability-analyzer': 'skilleto-icon-sap',
  'sap-web-dynpro': 'skilleto-icon-sap',
  debian: 'skilleto-icon-debian',
  'rollup-dot-js': 'skilleto-icon-rollup-dot-js',
  yii: 'skilleto-icon-yii',
  yii2: 'skilleto-icon-yii',
  ngrx: 'skilleto-icon-ngrx',
  intercom: 'skilleto-icon-intercom',
  'ms-sql': 'skilleto-icon-ms-sql',
  'microsoft-sql': 'skilleto-icon-ms-sql',
  ssis: 'skilleto-icon-ssis',
  powershell: 'skilleto-icon-powershell',
  opengl: 'skilleto-icon-opengl',
  opencv: 'skilleto-icon-opencv',
  openvpn: 'skilleto-icon-openvpn',
  'tailwind-css': 'skilleto-icon-tailwind-css',
  clickup: 'skilleto-icon-clickup',
  celery: 'skilleto-icon-celery',
  teradata: 'skilleto-icon-teradata',
  svelte: 'skilleto-icon-svelte',
  mobile: 'skilleto-icon-mobile',
  tableau: 'skilleto-icon-tableau',
  databricks: 'skilleto-icon-databricks',
  pandas: 'skilleto-icon-pandas',
  spark: 'skilleto-icon-spark',
  'spark-streaming': 'skilleto-icon-spark',
  pyspark: 'skilleto-icon-spark',
  keboola: 'skilleto-icon-keboola',
  'power-bi': 'skilleto-icon-power-bi',
  airflow: 'skilleto-icon-airflow',
  'backbone-dot-js': 'skilleto-icon-backbone-dot-js',
  mocha: 'skilleto-icon-mocha',
  'google-cloud-platform': 'skilleto-icon-google-cloud-platform',
  'azure-devops': 'skilleto-icon-azure-devops',
  openshift: 'skilleto-icon-openshift',
  c: 'skilleto-icon-c',
  'big-data': 'skilleto-icon-big-data',
  datadog: 'skilleto-icon-datadog',
  blockchain: 'skilleto-icon-blockchain',

  'anatomie-krav': 'skilleto-icon-anatomie-krav',
  'planety-slunecni-soustavy': 'skilleto-icon-planety-slunecni-soustavy',
};

// deprecated
export const svgBySlug = {};
